<template>
  <div class="drawer_main">
    <a-drawer
      :title="title"
      :width="720"
      :visible="addRoleDrawerVisible"
      wrap-class-name="filter-drawer-group pc_role_drawer"
      @close.stop="onClose"
    >
      <a-alert
        v-if="showAlert"
        :message="alertTip"
        type="info"
        show-icon
      />
      <a-form
        :form="form"
        style="margin-top: 24px;margin-bottom: 50px;"
        hide-required-mark
      >
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${roleNameTit}：`"
        >
          <div class="role_name">
            <a-input
              v-decorator="['rolename', { initialValue: roles.rolename, rules: [{ required: true, validator: roleValidate }] }]"
              :maxlength="5"
              class="marginl16"
              @change.stop="handleRole"
            />
            <span class="input_suffix">{{ roles.rolename.length >= 5 ? 5 : roles.rolename.length }}/5</span>
          </div>
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${roleManageTit}：`"
        >
          <div
            v-for="(item,index) in permissionDatas"
            :key="index+item.label"
            :class="['marginl16', 'h-auto', index === 1 && 'margint16', item.child.length > 1 && 'margin-bottom-24', 'clearfix']"
          >
            <div
              v-if="item.child.length === 1"
              class="float-div"
            >
              <a-checkbox
                :indeterminate="item.indeterminate"
                :checked="item.selected"
                :disabled="item.disabled"
                @change="onCheckAllChange($event,item,index)"
              >
                {{ item.label }}
              </a-checkbox>
            </div>
            <div
              v-else
              class="normal-div"
            >
              <a-checkbox
                :indeterminate="item.indeterminate"
                :checked="item.selected"
                :disabled="item.disabled"
                @change="onCheckAllChange($event,item,index)"
              >
                {{ item.label }}
              </a-checkbox>
            </div>
            <div v-if="item.level === 3">
              <div
                v-for="(items3,index3) in item.child"
                :key="index3"
                :class="['margin-left-32', items3.child.length === 0 ? 'margint16' : 'margin-bottom-40']"
              >
                <a-checkbox
                  :indeterminate="items3.indeterminate"
                  :checked="items3.selected"
                  :disabled="items3.disabled"
                  class="margin-normal"
                  @change="onCheckAllChangeSecond($event,items3,index3,item,index)"
                >
                  {{ items3.label }}
                </a-checkbox>
                <br>
                <div class="margin-left-32">
                  <a-checkbox
                    v-for="(item4, index4) in items3.child"
                    :key="item4.value"
                    :disabled="item4.disabled"
                    :checked="item4.selected"
                    @change="onCheckAllGrand($event, {item4, index4, items3, index3, item, index})"
                  >
                    {{ item4.label }}
                    <a-popover
                      v-if="item4.tips"
                      placement="topLeft"
                      overlay-class-name="universal-tips-pop"
                    >
                      <template slot="content">
                        <p>{{ item4.tips }}</p>
                      </template>
                      <i class="iconfont iconicon-test31" />
                    </a-popover>
                  </a-checkbox>
                </div>
              </div>
            </div>
            <div
              v-else-if="item.level!==3 && item.child.length > 1"
              class="margin-left-32"
            >
              <a-checkbox-group
                v-model="item.defaultSelect"
                class="margint16 h-auto"
                :options="item.child"
                @change="onChange($event,item,index)"
              />
            </div>
            <div
              v-else-if="item.level!==3 && item.child.length === 1"
              class="float"
            >
              <a-checkbox-group
                v-model="item.defaultSelect"
                :options="item.child"
                :disabled="parentIsChecked(item)"
                class="marginl100"
                @change="onChange($event,item,index)"
              />
            </div>
          </div>
        </a-form-item>
      </a-form>
      <div
        class="event-footer-div"
      >
        <a-button
          type="primary"
          class="save-btn"
          :loading="rolemanageLoading"
          @click.stop="onSave"
        >
          {{ $t('message["21"]') }}
        </a-button>
        <a-button @click.stop="onClose">
          {{ $t('message["896"]') }}
        </a-button>
        <a-button
          v-if="Object.keys(roleInfo).length > 0"
          style="background: #F57676; color: #fff"
          @click.stop="deleteRoles"
        >
          {{ $t('message["962"]') }}
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapState, mapActions, mapMutations } from 'vuex'
const formItemLayout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 20 }
}
// 关联的关键ID
const ADD_REVIEW_INDEX = 36 // 新增评论
const DEL_COMMENTS = 120 // 删除评论
const REVIEW_CONTENT_INDEX = 34 // 评论内容
const REVIEW_CONTENT_PARENT_INDEX = 43 // 信息查看权限
const INFO_EDIT_INDEX = 25 // 信息编辑权限
const EDIT_BEIAN = 121 // 信息编辑下的编辑备案权限
const EDIT_INFO_PLAN = 122 // 编辑推广方式
const SEE_INFO_DETAIL_INDEX = 15
const ADD_VISIT_RECORD = 40
const DEL_VISIT_RECORD = 41
const SOURCE_DETAIL_INDEX = 32
const VISIT_RECORD_INDEX = 33 // 回访记录
const SEE_BASE_INFO = 83
const BASE_INFO_INDEX = 84
const INFO_DETAIL_INDEX = 85
const SEE_INFO_FOLLOW_INDEX = 21
const POPULARIZE_METHODS_INDEX = 18 // 推广方式
const INFO_DEVELOPMENT_INDEX = 81 // 信息开发权限：可进行信息关联配置
const INFO_ADMIT_INDEX = 1 // 信息接待（信息录入）权限
const INFO_FOLLOW_UP = 12 // 信息跟进权限
const INFO_VERIFY_INDEX = 2 // 信息审核权限
const INFO_CHECK_INDEX = 3 // 信息查重权限
const UNIVERSAL_FORM = 94
const INQUERY_SOURCE = 113 // 信息编辑的 来源详情

const SALES_SYSTEM_ROLE = 5 // 销售
const INFO_CHECK_REPEAT = 3 // 信息查重权限
const roleValidate = function (rule, value, callback) {
  value = value.trim()
  let length = value.length
  if (length === 0) {
    callback(new Error(this.$t('message["779"]')))
  }
  callback()
}
export default {
  props: {
    roleInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      permissionDatas: [], // 角色权限
      formItemLayout,
      roles: {
        rolename: ''
      },
      indeterminate: false,
      checkAll: false,
      visible: false,
      form: this.$form.createForm(this),
      // 判断【信息开发权限】|【信息接待权限】是否被选中，用于禁用【推广方式】
      isSelectedAdmitDevelopment: false
    }
  },
  computed: {
    ...mapState('role', ['addRoleDrawerVisible', 'rolemanageLoading', 'permissionList', 'roleManageDesc', 'showNotification']),
    isSales () {
      return this.roles.system_role === SALES_SYSTEM_ROLE
    },
    showAlert () {
      return this.roleInfo && Object.keys(this.roleInfo).length === 0
    },
    title () {
      const { rolename } = this.roleInfo
      // console.log(this.roleInfo)
      return rolename ? `${this.$t('message["413"]')}${rolename}` : this.$t('message["414"]')
    },
    delMemberTip () {
      return this.$t('message["161"]').split('|')
    },
    roleNameTit () {
      return this.$t('message["506"]')
    },
    roleManageTit () {
      return this.$t('message["507"]')
    },
    alertTip () {
      return this.$t('message["1256"]')
    }
  },
  watch: {
    permissionList (val) {
      if (!val) return
      this.permissionDatas = this.formatePermissionDatas(val)
    },
    showNotification (val) {
      val && this.openInfoRepeatNotification()
      // 初始化
      val && this.setShowNotification(false)
    },
    addRoleDrawerVisible (val) {
      if (val) {
        // console.log(this.roleInfo)
        if (!this.showAlert) {
          this.roles = JSON.parse(JSON.stringify(this.roleInfo))
        }
        this.$nextTick(() => {
          this.form.setFieldsValue({ rolename: this.roles.rolename })
        })
      } else {
        this.onClose()
      }
    }
  },
  mounted () {
    window.scroll(0, 0)
  },
  destroyed () {
    this.onClose()
  },
  methods: {
    ...mapActions('role', ['fetchAddRole', 'fetchEditRole', 'fetchDeleteRole']),
    ...mapMutations('role', ['setShowNotification', 'SET_ADD_ROLE_VISIBLE', 'DEL_ROLE_LIST']),
    roleValidate,
    parentIsChecked (item) {
      return !item.selected
    },
    onClose () {
      this.form.setFieldsValue({ rolename: '' })
      this.roles = Object.assign({}, { rolename: '' })
      this.SET_ADD_ROLE_VISIBLE(false)
    },
    judgeSelectedAll (item) {
      if ('child' in item) {
        if (item.child.length > 1) {
          let isAllCancel = item.child.every(child => child.selected === false)
          if (isAllCancel) {
            return false
          } else {
            let isOtherSelected = item.child.some(child => child.selected === false)
            if (isOtherSelected) {
              return true
            } else {
              return false
            }
          }
        }
      }
      return false
    },
    // 格式化初试数据
    formatePermissionDatas (value) {
      let tempArray = []
      if (Array.isArray(value)) {
        value.map(values => {
          const json = {
            label: values.name,
            value: values.id,
            indeterminate: this.judgeSelectedAll(values),
            level: 0,
            disabled: !values.cancel,
            selected: values.selected,
            defaultSelect: [],
            child: []
          }
          if (values.child) {
            values.child.forEach((item, index) => {
              if (item.selected) {
                json.defaultSelect.push(item.id)
              }
              const jsonSecond = {
                label: item.name,
                value: item.id,
                indeterminate: this.judgeSelectedAll(item),
                disabled: !item.cancel,
                selected: item.selected,
                defaultSelect: [],
                child: []
              }
              if (item.float) {
                jsonSecond.float = item.float
              }
              if (item.child) {
                json.level = 3
                item.child.forEach(items => {
                  if (items.selected) {
                    jsonSecond.defaultSelect.push(items.id)
                  }
                  jsonSecond.child.push({
                    label: items.name,
                    value: items.id,
                    selected: items.selected,
                    disabled: !items.cancel,
                    tips: items.tips
                  })
                })
              }
              json.child.push(jsonSecond)
            })
          }
          tempArray.push(json)
        })
      }
      return this.initDisabled(tempArray)
    },
    itemDisabled (item, parent, filter) {
      return item.child.map(son => {
        if (filter.includes(son.value)) {
          son.disabled = parent.selected
        }
        return son
      })
    },
    recurDisabled (item, disabled) {
      item = item.map(pChild => {
        pChild.disabled = disabled
        if (disabled) {
          pChild.selected = !disabled
          pChild.indeterminate = !disabled
        }
        if ('child' in pChild) {
          pChild.child = pChild.child.map(sChild => {
            sChild.disabled = disabled
            if (disabled) {
              sChild.selected = !disabled
            }
            return sChild
          })
        }
        return pChild
      })
      return item
    },
    // 初始化checkbox禁用状态
    initDisabled (list) {
      let addReviewChecked = false // 新增评论是否选中
      let addIsChecked = false // 新增/删除回访记录是否选中
      for (let index = 0; index < list.length; index++) {
        let parent = list[index]
        const { value } = parent
        if (Object.keys(this.roleInfo).length === 0) {
        // 默认禁用信息查看和信息编辑
          if ([REVIEW_CONTENT_PARENT_INDEX, INFO_EDIT_INDEX, UNIVERSAL_FORM].includes(value)) {
            parent.disabled = true
            parent.selected = false
            this.recurDisabled(parent.child, true)
          }
        }
        // 【信息跟进】关联【信息查看】和【信息编辑】
        if (value === INFO_FOLLOW_UP) {
          if (parent.selected) {
            for (let i = 0; i < list.length; i++) {
              let item = list[i]
              if (item.value === INFO_EDIT_INDEX) {
                item.disabled = parent.selected
                item.child = this.itemDisabled(item, parent, [BASE_INFO_INDEX, INFO_DETAIL_INDEX])
                addReviewChecked = item.child.some(child => child.value === ADD_REVIEW_INDEX && child.selected)
                // console.log(addReviewChecked)
                // 【新增评论】关联【评论内容】
                if (addReviewChecked === true) {
                  if (this.isSales) {
                    item.child = item.child.map(child => {
                      if (child.value === ADD_REVIEW_INDEX) {
                        child.disabled = true
                      }
                      return child
                    })
                  }
                  for (let ai = 0; ai < list.length; ai++) {
                    let aItem = list[ai]
                    // 信息查看权限
                    if (aItem.value === REVIEW_CONTENT_PARENT_INDEX) {
                      aItem.child = aItem.child.map(child => {
                        if (child.value === REVIEW_CONTENT_INDEX) {
                          child.disabled = addReviewChecked
                        }
                        return child
                      })
                    }
                  }
                }
                // 禁用
                break
              }
              if (item.value === REVIEW_CONTENT_PARENT_INDEX) {
                // console.log('查看')
                item.child = this.itemDisabled(item, parent, [SEE_BASE_INFO, SEE_INFO_DETAIL_INDEX])
              }
            }
            addIsChecked = parent.child.some(child => {
              return [ADD_VISIT_RECORD, DEL_VISIT_RECORD].includes(child.value) && child.selected
            })
            if (addIsChecked) {
              // 【新增回访记录】和【删除回访记录】关联【回访记录】
              for (let i = 0; i < list.length; i++) {
                let item = list[i]
                item.child = item.child.map(child => {
                  if (child.value === VISIT_RECORD_INDEX) {
                    child.disabled = addIsChecked
                  }
                  return child
                })
              }
            }
          } else {
            parent.child = parent.child.map(child => {
              child.disabled = !parent.selected
              return child
            })
          }
        }
        // 【信息开发权限】关联【来源详情】
        if (value === INFO_DEVELOPMENT_INDEX) {
          if (parent.selected) {
            // 禁用【来源详情】
            for (let i = 0; i < list.length; i++) {
              let item = list[i]
              if (item.value === REVIEW_CONTENT_PARENT_INDEX) { // 信息查看权限
                item.child = item.child.map(cVal => {
                  if (cVal.value === SOURCE_DETAIL_INDEX) {
                    cVal.disabled = parent.selected
                  }
                  return cVal
                })
                break
              }
            }
          }
        }
        if (value === INFO_EDIT_INDEX) {
          parent.child = parent.child.map(child => {
            if (child.value === ADD_REVIEW_INDEX) {
              if (child.selected) {
                for (let ai = 0; ai < list.length; ai++) {
                  let aItem = list[ai]
                  if (aItem.value === REVIEW_CONTENT_PARENT_INDEX) { // 信息查看权限
                    aItem.child = aItem.child.map(child => {
                      if (child.value === REVIEW_CONTENT_INDEX) {
                        child.disabled = child.selected
                      }
                      return child
                    })
                  }
                }
              }
            }
            return child
          })
        }
        // 【信息查重权限】关联【查看查重详情】和【查重详情编辑】
        if (value === INFO_CHECK_REPEAT) {
          let isSelected = false
          parent.child = parent.child.map(child => {
            child.disabled = !parent.selected || parent.disabled
            if (parent.selected && child.value === 109) {
              child.selected && !child.disabled ? isSelected = true : isSelected = false
            }
            return child
          })
          parent.child.forEach(item => {
            if (item.value === 44) {
              item.disabled = !isSelected
            }
          })
        }
      }
      return list
    },
    // 保存/更新名称
    onSave () {
      const _this = this
      this.form.validateFields(err => {
        if (!err) {
          let permission = !this.isSelectBasePermission() ? [] : _this.getSelectedId()
          if (permission.length === 0) {
            _this.$message.warning(this.$t('message["508"]'))
            return
          }
          let params = { rolename: _this.roles.rolename, permission }
          if (Object.keys(_this.roleInfo).length === 0) {
            // 新增
            _this.fetchAddRole(params)
          } else {
            // 管理更新
            params = Object.assign(params, { roleid: _this.roles.roleid })
            _this.fetchEditRole(params)
          }
        }
      })
    },
    // 信息查重开启提示【repeatState】
    openInfoRepeatNotification () {
      const key = this.roles.roleid
      const btn = <div>
        <a-button type="primary" size="small" onClick={() => this.toInfoRepeat(key)}>{this.$t('message["598"]')}</a-button>
        <a-button size="small" onClick={() => this.colseNotification(key)}>{this.$t('message["1004"]')}</a-button>
      </div>
      this.$notification['warning']({
        message: this.$t('message["1356"]'),
        description: this.$t('message["1290"]'),
        btn,
        key,
        class: 'role-notification'
      })
    },
    colseNotification (key) {
      this.$notification.close(key)
    },
    toInfoRepeat (key) {
      this.colseNotification(key)
      this.$router.push({ name: 'configRepeat' })
    },
    getSelectedId () {
      let selectedId = []
      if (Array.isArray(this.permissionDatas)) {
        this.permissionDatas.map(value => {
          if (value.selected) {
            selectedId.push(value.value)
          }
          if (value.child) {
            value.child.map(vvs => {
              selectedId = selectedId.concat(vvs.defaultSelect)
            })
          }
          selectedId = selectedId.concat(value.defaultSelect)
        })
      }
      return selectedId
    },
    onChange (checkedList, item, index) {
      // console.log({ key: 'ok', checkedList, item, index })
      item.indeterminate = !!checkedList.length && (checkedList.length < item.child.length)
      if (!item.child[0].float) {
        item.selected = checkedList.length === item.child.length
      } else {
        item.defaultSelect = checkedList
      }
      if (item.value === INFO_FOLLOW_UP) {
        if (checkedList.includes(ADD_VISIT_RECORD) || checkedList.includes(DEL_VISIT_RECORD)) {
          // console.log('VISIT_RECORD_INDEX')
          this.permissionDatas = this.permissionDatas.map(val => {
            if (val.value === REVIEW_CONTENT_PARENT_INDEX) { // 信息查看权限
              val.child = val.child.map(cVal => {
                if (cVal.value === VISIT_RECORD_INDEX) {
                  cVal.selected = true
                  cVal.disabled = true
                  !val.defaultSelect.includes(VISIT_RECORD_INDEX) && val.defaultSelect.push(VISIT_RECORD_INDEX)
                }
                return cVal
              })
            }
            return val
          })
        } else {
          // 取消勾选【回访记录】
          this.permissionDatas = this.permissionDatas.map(val => {
            if (val.value === REVIEW_CONTENT_PARENT_INDEX) { // 信息查看权限
              val.child = val.child.map(cVal => {
                if (cVal.value === VISIT_RECORD_INDEX) {
                  cVal.disabled = false
                }
                return cVal
              })
            }
            return val
          })
        }
      }

      // 【信息查重权限】关联【查看查重详情】和【查重详情编辑】
      if (item.value === INFO_CHECK_REPEAT) {
        const isChecked = checkedList.includes(109)
        this.permissionDatas = this.permissionDatas.map(val => {
          if (val.value === INFO_CHECK_REPEAT) {
            val.child = val.child.map(cVal => {
              if (cVal.value === 44) {
                if (!isChecked) {
                  cVal.selected = false
                }
                cVal.disabled = !isChecked
                if (!isChecked && val.defaultSelect.includes(44)) {
                  val.defaultSelect.splice(val.defaultSelect.findIndex(item => item === 44), 1)
                }
              }
              return cVal
            })
          }
          return val
        })
      }
      this.$set(this.permissionDatas, index, item)
    },
    onCheckAllGrand (e, other) {
      const { checked } = e.target
      // console.log({ checked, other })
      const { item4: currentItem, index4: currentIndex, items3: item, index3: index, item: parentItem, index: parentIndex } = other
      if ('child' in item && item.child.length > 0) {
        item.child[currentIndex].selected = checked
      }
      // console.log(currentItem.value)
      let isInclude = item.defaultSelect.includes(currentItem.value)
      let currentLabel = currentItem.label
      // 【信息查看权限】和【信息编辑权限】互相关联
      if (parentItem.value === INFO_EDIT_INDEX) {
        // 勾选后关联【信息查看权限】相关字段
        if (checked) {
          for (let i = 0; i < this.permissionDatas.length; i++) {
            let per = this.permissionDatas[i]
            if (per.value === REVIEW_CONTENT_PARENT_INDEX) { // 信息查看权限
              for (let k = 0; k < per.child.length; k++) {
                let pChild = per.child[k]
                if (pChild.label === item.label) {
                  this.$set(this.permissionDatas, i, per)
                  pChild.child = pChild.child.map(grand => {
                    if (currentLabel === grand.label) {
                      !pChild.defaultSelect.includes(grand.value) && pChild.defaultSelect.push(grand.value)
                      grand.selected = true
                    }
                    return grand
                  })
                  break
                }
              }
            }
          }
        }
      }
      if (parentItem.value === REVIEW_CONTENT_PARENT_INDEX) { // 信息查看权限
        // 取消勾选关联【信息编辑权限】相关字段
        if (!checked) {
          for (let i = 0; i < this.permissionDatas.length; i++) {
            let per = this.permissionDatas[i]
            // 停止循环标识符
            let isOver = false
            if (per.value === INFO_EDIT_INDEX) {
              for (let k = 0; k < per.child.length; k++) {
                let perChild = per.child[k]
                if (isOver) break
                if (perChild.child.length > 0) {
                  for (let grand = 0; grand < perChild.child.length; grand++) {
                    let grandItem = perChild.child[grand]
                    if (grandItem.label === currentLabel) {
                      // 取消编辑中对于的选项
                      grandItem.selected = false
                      let defaultIndex = perChild.defaultSelect.indexOf(grandItem.value)
                      defaultIndex !== -1 && perChild.defaultSelect.splice(defaultIndex, 1)
                      isOver = true
                      break
                    }
                  }
                }
              }
              break
            }
          }
        }
      }
      if (checked) {
        !isInclude && item.defaultSelect.push(currentItem.value)
      } else {
        let defaultIndex = item.defaultSelect.indexOf(currentItem.value)
        isInclude && item.defaultSelect.splice(defaultIndex, 1)
      }
      item.indeterminate = !!item.defaultSelect.length && (item.defaultSelect.length < item.child.length)
      item.selected = item.defaultSelect.length === item.child.length
      parentItem.child[index] = item
      this.$set(this.permissionDatas, parentIndex, parentItem)
    },
    // 判断基础的5种权限是否选择其一
    isSelectBasePermission () {
      for (let i = 0; i < this.permissionDatas.length; i++) {
        let item = this.permissionDatas[i]
        if ([INFO_DEVELOPMENT_INDEX, INFO_ADMIT_INDEX, INFO_FOLLOW_UP, INFO_VERIFY_INDEX, INFO_CHECK_INDEX].includes(item.value)) {
          if (item.selected) {
            return true
          }
        }
      }
      return false
    },
    onCheckAllChange (e, item, index) {
      // console.log({ key: 'onCheckAllChange', e, item, index })
      const { checked } = e.target
      if (Array.isArray(item.child)) {
        if (item.child.length > 0) {
          if (!item.child[0].float) {
            item.defaultSelect = []
          }
        }
        if (item.child.length === 1) {
          item.child = item.child.map(value => {
            if (!checked) {
              value.selected = checked
              item.defaultSelect = []
            }
            return value
          })
        }
        // 选中【信息开发、接待、审核、跟进、查重】后释放【信息查看】【信息编辑】的禁用状态
        if ([INFO_DEVELOPMENT_INDEX, INFO_ADMIT_INDEX, INFO_FOLLOW_UP, INFO_VERIFY_INDEX, INFO_CHECK_INDEX].includes(item.value)) {
          let isSelectBase = this.isSelectBasePermission()
          if (!isSelectBase) {
            for (let i = 0; i < this.permissionDatas.length; i++) {
              let parent = this.permissionDatas[i]
              const { value } = parent
              if ([REVIEW_CONTENT_PARENT_INDEX, INFO_EDIT_INDEX, UNIVERSAL_FORM].includes(value)) {
                parent.disabled = false
                parent.child = this.recurDisabled(parent.child, false)
              }
            }
          }
        }
        // 【信息跟进权限】关联【信息编辑权限】【信息查看权限】-基础信息|信息详情
        if (item.value === INFO_FOLLOW_UP) {
          // 关联【信息编辑权限】
          this.joinFollowToEdit(checked)
          // 取消/禁用【信息编辑权限】子集
          if (!checked) {
            // console.log('禁用')
            item.defaultSelect = []
            item.child = item.child.map(child => {
              child.selected = checked
              child.disabled = checked
              // child.indeterminate = checked
              return child
            })
          } else {
            item.child = item.child.map(child => {
              child.disabled = checked
              // child.indeterminate = checked
              return child
            })
          }
        }

        // 【信息开发权限】关联【信息查看权限】-来源详情
        if (item.value === INFO_DEVELOPMENT_INDEX) {
          for (let i = 0; i < this.permissionDatas.length; i++) {
            let val = this.permissionDatas[i]
            if (val.value === REVIEW_CONTENT_PARENT_INDEX) {
              val.child = val.child.map(cVal => {
                if (cVal.value === SOURCE_DETAIL_INDEX) {
                  cVal.disabled = checked
                  if (checked) {
                    cVal.selected = checked
                  }
                }
                return cVal
              })
            }
          }
        }
        item.child = item.child.map((value, indexchild) => {
          if (item.value === INFO_FOLLOW_UP) {
            value.disabled = !checked
          }
          let defaultSelect = item.defaultSelect
          if (checked) {
            if (!value.disabled) {
              if (!value.float) {
                value.selected = checked
                !defaultSelect.includes(value.value) && defaultSelect.push(value.value)
              } else {
                if (value.selected) {
                  !defaultSelect.includes(value.value) && defaultSelect.push(value.value)
                }
              }
            } else {
              if (value.selected) {
                !defaultSelect.includes(value.value) && defaultSelect.push(value.value)
              }
            }
          } else {
            // console.log('取消', value)
            value.selected = checked
            if (!value.disabled) {
              if (!value.float) {
                value.selected = checked
              }
            } else {
              // value.disabled = checked
              if (value.selected) {
                !defaultSelect.includes(value.value) && defaultSelect.push(value.value)
              }
            }
          }
          if (value.child) {
            if (value.child.length > 0) {
              value.defaultSelect = []
              value.indeterminate = false
              value.child.map(items => {
                if (checked) {
                  if (!items.disabled) {
                    items.selected = checked
                    !value.defaultSelect.includes(items.value) && value.defaultSelect.push(items.value)
                  } else {
                    if (items.selected) {
                      !value.defaultSelect.includes(items.value) && value.defaultSelect.push(items.value)
                    }
                  }
                } else {
                  if (!items.disabled) {
                    // console.log('ttt', checked)
                    items.selected = checked
                  } else {
                    if (items.selected) {
                      !value.defaultSelect.includes(items.value) && value.defaultSelect.push(items.value)
                    }
                  }
                }
              })
            }
          }
          return value
        })
        item.indeterminate = false
        item.selected = checked

        // 【信息查重权限】关联【查看查重详情】和【查重详情编辑】
        if (item.value === INFO_CHECK_REPEAT) {
          item.child = item.child.map(val => {
            val.disabled = !checked
            if (!checked) {
              val.selected = false
            } else {
              if (val.value === 44) {
                val.disabled = true
              }
            }

            return val
          })
          if (!checked) {
            item.defaultSelect = []
          }
        }
        this.$set(this.permissionDatas, index, item)
        // this.$set(this.permissionDatas, index, item)
        // 【信息开发权限】和【信息接待权限】关联【推广方式】的选中和禁用
        if ([INFO_ADMIT_INDEX, INFO_DEVELOPMENT_INDEX].includes(item.value)) {
          // console.log('推广方式', item)
          if (checked) {
            this.isSelectedAdmitDevelopment = checked
          } else {
            let count = 0
            for (let i = 0; i < this.permissionDatas.length; i++) {
              let parent = this.permissionDatas[i]
              // console.log(parent, count)
              if (count === 2) {
                this.isSelectedAdmitDevelopment = false
                break
              }
              if (parent.value === INFO_ADMIT_INDEX && !parent.selected) {
                // console.log(parent, INFO_ADMIT_INDEX)
                count++
              }
              if (parent.value === INFO_DEVELOPMENT_INDEX && !parent.selected) {
                // console.log(parent, INFO_DEVELOPMENT_INDEX)
                count++
              }
            }
          }
          // console.log(this.isSelectedAdmitDevelopment)
          for (let i = 0; i < this.permissionDatas.length; i++) {
            let pre = this.permissionDatas[i]
            if (pre.value === REVIEW_CONTENT_PARENT_INDEX) { // 信息查看权限
              for (let son = 0; son < pre.child.length; son++) {
                let sonItem = pre.child[son]
                // console.log(sonItem)
                if (sonItem.value === SEE_BASE_INFO && 'child' in sonItem) {
                  for (let grand = 0; grand < sonItem.child.length; grand++) {
                    let grandItem = sonItem.child[grand]
                    if (grandItem.value === POPULARIZE_METHODS_INDEX) {
                      if (checked) {
                        grandItem.selected = checked
                        !sonItem.defaultSelect.includes(grandItem.value) && sonItem.defaultSelect.push(grandItem.value)
                      }
                      // console.log(pre.defaultSelect)
                      grandItem.disabled = this.isSelectedAdmitDevelopment
                      break
                    }
                  }
                  sonItem.selected = sonItem.defaultSelect.length === sonItem.child.length
                  sonItem.indeterminate = !!sonItem.defaultSelect.length && (sonItem.defaultSelect.length < sonItem.child.length)
                  break
                }
              }
              break
            }
          }
        }
        this.$set(this.permissionDatas, index, item)
        // 当5中基本权限全部取消后触发
        console.log(this.permissionDatas)
        if (!this.isSelectBasePermission()) {
          console.log('full', this.permissionDatas)
          for (let i = 0; i < this.permissionDatas.length; i++) {
            let parent = this.permissionDatas[i]
            const { value } = parent
            if ([REVIEW_CONTENT_PARENT_INDEX, INFO_EDIT_INDEX, UNIVERSAL_FORM].includes(value)) {
              parent.disabled = true
              parent.selected = false
              parent.indeterminate = false
              parent.defaultSelect = []
              // parent.child = this.recurDisabled(parent.child, true)
              parent.child = parent.child.map(sChild => {
                sChild.selected = false
                sChild.disabled = true
                sChild.indeterminate = false
                sChild.defaultSelect = []
                if ('child' in sChild) {
                  sChild.child = sChild.child.map(gChild => {
                    gChild.selected = false
                    gChild.disabled = true
                    return gChild
                  })
                }
                return sChild
              })
            }
            // if ([REVIEW_CONTENT_PARENT_INDEX, INFO_EDIT_INDEX].includes(value)) {
            //   parent.disabled = true
            //   parent.selected = false
            //   parent.indeterminate = false
            //   parent.child = this.recurDisabled(parent.child, true)
            // }
          }
        }
      }
    },
    // 【信息跟进权限】关联【信息编辑权限】【信息查看权限】-基础信息|信息详情
    joinFollowToEdit (checked) {
      // console.log(checked)
      for (let i = 0; i < this.permissionDatas.length; i++) {
        let val = this.permissionDatas[i]
        if (val.value === INFO_EDIT_INDEX) { // 信息编辑权限
          val.child = val.child.map((cVal, cIndex) => {
            const { value } = cVal
            if ([BASE_INFO_INDEX, INFO_DETAIL_INDEX].includes(value)) {
              // console.log(cVal)
              !val.defaultSelect.includes(BASE_INFO_INDEX) && val.defaultSelect.push(BASE_INFO_INDEX)
              !val.defaultSelect.includes(INFO_DETAIL_INDEX) && val.defaultSelect.push(INFO_DETAIL_INDEX)
              cVal.disabled = checked
              if (checked) {
                // cVal.defaultSelect = cVal.child.map(child => child.value)
                cVal.defaultSelect = _.reduce(cVal.child, (res, child) => {
                  if (child.selected) {
                    res.push(child.value)
                  } else if (child.value !== EDIT_BEIAN && child.value !== EDIT_INFO_PLAN) {
                    res.push(child.value)
                  }
                  return res
                }, [])
                cVal.selected = checked
              }
              cVal.indeterminate = !!cVal.defaultSelect.length && (cVal.defaultSelect.length < cVal.child.length)
              cVal.child = cVal.child.map(child => {
                // 除了编辑备案权限，其他都置灰
                if ((child.value !== EDIT_BEIAN && child.value !== EDIT_INFO_PLAN) && child.value !== 27) { // EDIT_BEIAN： 编辑备案权限
                  child.disabled = checked
                }
                // 如果信息跟进权限选中，信息编辑权限下的除了编辑备案权限，其他选中
                if (checked && (child.value !== EDIT_BEIAN && child.value !== EDIT_INFO_PLAN)) {
                  child.selected = checked
                }
                return child
              })
            }
            return cVal
          })
          val.disabled = checked
          // 判读是否全选/半选
          val.indeterminate = !!val.defaultSelect.length && (val.defaultSelect.length < val.child.length)
        }
        if (val.value === REVIEW_CONTENT_PARENT_INDEX) {
          // console.log(val, SEE_INFO_FOLLOW_INDEX)
          val.child = val.child.map(son => {
            if (son.value === SEE_BASE_INFO) {
              !son.defaultSelect.includes(SEE_INFO_FOLLOW_INDEX) && son.defaultSelect.push(SEE_INFO_FOLLOW_INDEX)
              son.indeterminate = !!son.defaultSelect.length && (son.defaultSelect.length < son.child.length)
              son.child = son.child.map(grand => {
                if (grand.value === SEE_INFO_FOLLOW_INDEX) {
                  if (checked) {
                    grand.selected = checked
                  }
                  grand.disabled = checked
                }
                return grand
              })
            }
            if (son.value === SEE_INFO_DETAIL_INDEX) {
              // console.log(son, SEE_INFO_DETAIL_INDEX)
              son.disabled = checked
              son.child = son.child.map(grand => {
                !son.defaultSelect.includes(grand.value) && son.defaultSelect.push(grand.value)
                if (checked) {
                  grand.selected = checked
                }
                grand.disabled = checked
                son.indeterminate = !!son.defaultSelect.length && (son.defaultSelect.length < son.child.length)
                return grand
              })
            }
            // 恢复【回访记录】的状态
            if (son.value === VISIT_RECORD_INDEX && !checked) {
              son.disabled = checked
            }
            return son
          })
        }
      }
    },
    /**
     * TODO 【新增评论|删除评论】强关联【评论内容】
     * @param checked 当前选中状态
     */
    joinAddReviewToContent (checked) {
      this.permissionDatas = this.permissionDatas.map(val => {
        if (val.value === REVIEW_CONTENT_PARENT_INDEX) { // 信息查看权限
          if (checked) {
            let isExit = val.defaultSelect.includes(REVIEW_CONTENT_INDEX)
            !isExit && val.defaultSelect.push(REVIEW_CONTENT_INDEX)
          }
          val.child = val.child.map(cVal => {
            if (cVal.value === REVIEW_CONTENT_INDEX) {
              cVal.disabled = checked
              if (checked) {
                cVal.selected = checked
              }
            }
            return cVal
          })
        }
        return val
      })
    },
    /**
     * TODO 【信息编辑权限】【来源详情】强关联【查看权限】【来源选择】
     * @param checked 当前选中状态
     */
    inqurySourceChecked (checked) {
      this.permissionDatas = this.permissionDatas.map(item => {
        if (item.value === REVIEW_CONTENT_PARENT_INDEX) { // 信息查看权限
          item.child = item.child.map(item2 => {
            const { value } = item2
            // 32是查看权限来源详情的id
            if (value === 32) {
              item2.selected = checked
              !item.defaultSelect.includes(value) && item.defaultSelect.push(value)
            }
            return item2
          })
        }
        return item
      })
    },
    onCheckAllChangeSecond (e, item, index, parentItem, parentIndex) {
      console.log({ key: 'onCheckAllChangeSecond', e, item, index, parentItem, parentIndex })
      let tempvs = []
      item.indeterminate = false
      const { checked } = e.target
      item.selected = checked
      // 【新增评论】强关联【评论内容】；销售可不用关联
      if (item.value === ADD_REVIEW_INDEX) {
        !this.isSales && this.joinAddReviewToContent(checked)
      }
      // 【 删除评论】强关联【评论内容】；选中删除评论内容时，必定勾选上评论内容。取消勾选时，双方互不干涉
      if (item.value === DEL_COMMENTS) {
        this.joinAddReviewToContent(checked)
      }

      // 选择来源详情，强关联信息查看权限的来源详情
      if (item.value === INQUERY_SOURCE && checked) {
        this.inqurySourceChecked(checked)
      }
      if (Array.isArray(item.child)) {
        item.defaultSelect = []
        item.child.map((value, index) => {
          if (checked) {
            if (!value.disabled) {
              value.selected = checked
              !item.defaultSelect.includes(value.value) && item.defaultSelect.push(value.value)
            } else {
              if (value.selected) {
                !item.defaultSelect.includes(value.value) && item.defaultSelect.push(value.value)
              }
            }
          } else {
            if (!value.disabled) {
              value.selected = checked
            } else {
              if (value.selected) {
                !item.defaultSelect.includes(value.value) && item.defaultSelect.push(value.value)
              }
            }
          }
        })
      }
      // 【信息编辑】和【信息查看】相互关联----【全选】
      if (parentItem.value === INFO_EDIT_INDEX && checked) {
        if (item.child.length > 0) {
          let currentLabel = item.label
          for (let i = 0; i < this.permissionDatas.length; i++) {
            let per = this.permissionDatas[i]
            if (per.value === REVIEW_CONTENT_PARENT_INDEX) { // 信息查看权限
              per.child = per.child.map(val => {
                const { label } = val
                if (label === currentLabel) {
                  val.selected = checked
                  val.child = val.child.map(grand => {
                    grand.selected = true
                    !val.defaultSelect.includes(grand.value) && val.defaultSelect.push(grand.value)
                    return grand
                  })
                }
                return val
              })
              break
            }
          }
        }
      }
      if (item.selected) {
        parentItem.defaultSelect.push(item.value)
      }
      if (parentItem.defaultSelect.length > 0) {
        parentItem.defaultSelect.map(vas => {
          if (vas === item.value) {
            if (item.selected) {
              tempvs.push(vas)
            }
          } else {
            tempvs.push(vas)
          }
        })
      } else {
        tempvs.push(item.value)
      }
      parentItem.child[index] = item
      parentItem.defaultSelect = tempvs
      this.$set(this.permissionDatas, parentIndex, parentItem)
    },
    handleRole (e) {
      const { value } = e.target
      this.roles['rolename'] = value
      // this.$set()
      // this.form.setFieldsValue({'rolename': value})
    },
    deleteRolesFail () {
      const title = <span class='del_title'>{ this.$t('message["975"]') }</span>
      const _this = this
      this.$confirm({
        title,
        iconType: 'exclamation-circle',
        closable: true,
        content: <p><span style="color: #F57676">{this.delMemberTip[0]}</span>{this.delMemberTip[1]}</p>,
        okText: this.$t('message["598"]'),
        cancelText: this.$t('message["1005"]'),
        onOk () {
          _this.$router.push({ name: 'TeamIndex' })
        },
        onCancel () {
          // console.log('Cancel')
        },
        class: 'del_model del_fail_model'
      })
    },
    // 删除自定义的角色
    deleteRoles () {
      const title = <span class='del_title'>{this.$t('message["491"]') }<a-tag>{this.roles.rolename}</a-tag></span>
      const _this = this
      this.$confirm({
        class: 'del_model',
        title: title,
        iconType: 'exclamation-circle',
        closable: true,
        content: <span style="color: #666">{this.$t('message["1520"]') }？</span>,
        async onOk () {
          const chain = await _this.fetchDeleteRole({ roleid: _this.roles.roleid })
          chain.onSuccess(payload => {
            _this.DEL_ROLE_LIST(_this.roles.roleid)
            _this.SET_ADD_ROLE_VISIBLE(false)
          })
            .onFail(() => {
              _this.deleteRolesFail()
            })
            .fetch()
        },
        onCancel () {
          // console.log('Cancel')
        }
      })
    }
  }
}
</script>
<style lang="scss">
.pc_role_drawer {
  label.ant-checkbox-wrapper {
    margin-bottom: 0;
  }
  i.iconicon-test31 {
    color: #d6d6d6;
  }
}
</style>
<style lang="scss" scoped>
.ant-input ::v-deep {
  width: 240px
}
.role_name {
  position: relative;
  display: inline-block;
}
.input_suffix {
  position: absolute;
  display: inline-block;
  right: 0;
  padding: 0 12px;
  border-left: 1px solid #D6D6D6;
  color: #D6D6D6;
  font-size: 18px;
}
.marginl16 {
  margin-left: 16px;
}
.role-name-span {
  height: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
}
.role-name-span-content {
  margin-left: 16px;
  height: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(179, 179, 179, 1);
  line-height: 24px;
}
.save-btn {
  margin-left: 105px;
  margin-right: 8px;
}
.event-footer-div {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 703px;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: left;
  z-index: 110;
  button {
    margin-right: 16px;
  }
}
.margin-left-32 {
  margin-left: 32px;
}
.float-div {
  float: left;
}
.float {
  float: left;
}
.margin-normal {
  margin-bottom: 0;
}
.normal-div:first-of-type {
  margin-top: 0;
}
</style>
<style lang="scss">
.role-notification {
  .ant-notification-notice-btn {
    float: left;
    margin-left: 45px;
  }
}
.pc_role_drawer {
  .ant-drawer-header {
    border-bottom: 0;
  }
  .ant-drawer-title {
    font-size: 32px;
    margin-top: 32px;
  }
  .ant-drawer-close {
    top: 44px;
  }
  .anticon-close {
    margin-right: 40px;
    font-size: 32px;
  }
}
.del_model {
  .del_title {
    font-weight: 600;
    margin-right: 8px;
    .ant-tag {
      margin: 0 8px;
    }
  }
  .ant-modal-body {
    .ant-modal-confirm-btns {
      position: relative;
      float: left;
      button:first-of-type {
        right: -110px;
      }
      button:last-of-type {
        position: absolute;
        left: 30px;
      }
    }
  }
}
.del_fail_model {
  .ant-modal-body {
    .ant-modal-confirm-btns {
      position: relative;
      float: left;
      button:first-of-type {
        right: -135px;
      }
    }
  }
}
</style>
